<template>
  <div class="home">
    <v-container grid-list-md>
      <v-layout row justify-center>
        <v-flex xs12 md6>
          <v-layout column align-center justify-space-between>
            <v-flex mb-5 mt-5>
              <img
                :src="require('@/assets/hil-logo-text-white.png')"
                width="200px"
              />
            </v-flex>
            <v-flex v-if="loading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-flex>
            <v-flex v-else>
              <LoginForm @login="redirect" v-if="isLogged === false" />
              <div v-else>Connecté</div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <div class="motto hidden-md-and-down">
      Ne cherchez plus, Home In Love trouve pour vous !
    </div>
    <v-snackbar v-model="showRenewOK" color="accent">
      Mot de passe modifié, vous pouvez vous connecter
    </v-snackbar>
  </div>
</template>

<script>
import { createInitialLease } from "@/services/lease";

// @ is an alias to /src
import LoginForm from "../components/LoginForm";

export default {
  name: "home",
  components: {
    LoginForm,
  },
  data() {
    return {
      loading: true,
      showRenewOK: false,
    };
  },
  async mounted() {
    await this.$store.dispatch("fetchStatus");
    this.loading = false;
    if (this.isLogged) {
      this.redirect();
    }
    if (this.$route.query.renew === "ok") {
      this.showRenewOK = true;
    }
  },
  methods: {
    async redirect() {
      await this.$store.dispatch("fetchStatus");
      if (!this.$store.state.user.initialized) {
        this.$router.push("/cgu");
        return;
      }
      if (this.$route.params.prevRoute) {
        this.$router.push(this.$route.params.prevRoute);
      } else if (this.$store.state.user.projectId == null) {
        // this.$router.push("/create-project");
        try {
          const leaseId = await createInitialLease();
          this.$router.push(`/leases/project/${leaseId}`);
        } catch {
          this.$router.push("/");
        }
      } else {
        this.$router.push(
          `/leases/project/${this.$store.state.user.projectId}`
        );
      }
    },
  },
  computed: {
    isLogged() {
      return this.$store.state.user.isLogged;
    },
  },
};
</script>

<style>
.motto {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  color: white;
  font-size: 18pt;
}
</style>
